Vue.use(Vuex);

import global from "./global/index.js";
import user from "./user/index.js";
import im from "./im/index.js";
import otc from "./otc/index.js";
import proTrading from './proTrading/index.js';
import swaps from './swap/index'
// import VuexPersistence from "vuex-persist";
import createPersistedState from "vuex-persistedstate";
import property from './property/index.js'
import tradingContest from './tradingContest/index.js'
import worldCup from './worldCup/index.js'

let timer = null;
const persistOptions = {
  key: 'yourKey',
  storage: {
    getItem: key => localStorage.getItem(key),
    setItem: (key, value) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        localStorage.setItem(key, value);
      }, 1000); // 延迟1秒
    },
    removeItem: key => localStorage.removeItem(key)
  }
};

// const vuexLocal = new VuexPersistence({
//     storage: window.localStorage
// })

const moduleB = {
    state: {},
    mutations: {},
    actions: {}
};

const store = new Vuex.Store({
    modules: {
        global,
        user,
        im,
        B: moduleB,
        otc,
        proTrading,
        swaps,
        property,
        tradingContest,
        worldCup
    },
    plugins: [createPersistedState(persistOptions)]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js